/**
 * Every Zoho Books salesperson, active or not.
 *
 * Endpoint: GET /accounts/:uuid/integrations/zoho/salespersons
 * Needs ACCOUNT_PATCH_ZOHO. Answers `[{ salespersonId, salespersonName,
 * salespersonEmail, isActive }]`.
 */
export const fetchZohoSalespersonsAction = ({ uuid }) => ({
  method: 'GET',
  endpoint: `/accounts/${uuid}/integrations/zoho/salespersons`,
});
